export const MAX_DIMENSION = 1_000_000;

export function dimensionData(node) {
    return Object.fromEntries(['width', 'height'].filter(key => node[key] !== undefined).map(key => [key, node[key]]));
}

export function validDimension(value) {
    return Number.isFinite(value) && value > 0 && value <= MAX_DIMENSION;
}

export function sizeSnapshot(node) {
    return { x: node.x, y: node.y, width: node.width, height: node.height };
}

export function applySize(node, data) {
    node.x = data.x; node.y = data.y;
    for (const key of ['width', 'height']) {
        if (data[key] === undefined) delete node[key];
        else node[key] = data[key];
    }
}

// Keep the opposite edge fixed while enforcing a readable minimum size.
export function resizedRectangle(rect, handle, delta, minimum) {
    const west = handle.includes('w'), east = handle.includes('e');
    const north = handle.includes('n'), south = handle.includes('s');
    const width = Math.max(minimum.width, Math.min(MAX_DIMENSION, rect.width + (east ? delta.x : west ? -delta.x : 0)));
    const height = Math.max(minimum.height, Math.min(MAX_DIMENSION, rect.height + (south ? delta.y : north ? -delta.y : 0)));
    return { x: west ? rect.x + rect.width - width : rect.x,
        y: north ? rect.y + rect.height - height : rect.y, width, height };
}

// Move a label along a ray until its entire rectangle clears every obstacle.
export function clearLabelPosition(origin, direction, size, obstacles, distance = 25) {
    const intervals = obstacles.map(rect => {
        let enter = -Infinity, exit = Infinity;
        for (const [axis, extent] of [['x', 'width'], ['y', 'height']]) {
            const low = rect[axis] - size[extent] / 2 - 6;
            const high = rect[axis] + rect[extent] + size[extent] / 2 + 6;
            if (Math.abs(direction[axis]) < 1e-10) {
                if (origin[axis] < low || origin[axis] > high) return null;
            } else {
                const a = (low - origin[axis]) / direction[axis], b = (high - origin[axis]) / direction[axis];
                enter = Math.max(enter, Math.min(a, b)); exit = Math.min(exit, Math.max(a, b));
            }
        }
        return enter <= exit ? { enter, exit } : null;
    }).filter(Boolean).sort((a, b) => a.enter - b.enter);
    for (const interval of intervals) if (distance >= interval.enter && distance <= interval.exit) distance = interval.exit + 1;
    return { x: origin.x + direction.x * distance - size.width / 2,
        y: origin.y + direction.y * distance - size.height / 2 };
}
